import { last } from "lodash";
import React, { useEffect, useState, useCallback } from "react";
import Iframe from "react-iframe";
import { ImageViewer } from "src/components/imageViewer";
import { ILicenseDocPreviewProps } from "./interfaces";
import { getDistributionUrl } from "./api";
import { IMAGE_TYPES } from "./constants";
import { showErrorToast } from "@src/appV2/lib/Notifications";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line react/function-component-definition
export const LicenseDocPreview: React.FC<ILicenseDocPreviewProps> = ({
  fileStorageFileKey,
  workerId,
  width,
  height,
  isPreviewImage = false,
  setLicense,
  license,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isImage, setIsImage] = useState<boolean>(false);
  const [url, setUrl] = useState<string>("");
  const [imagePath, setImagePath] = useState<string>("");

  const fetchFile = useCallback(async () => {
    setLoading(true);
    try {
      const distributionUrl = await getDistributionUrl(fileStorageFileKey, workerId);

      let extension = last(distributionUrl.toLowerCase().split("."));
      extension = extension?.split("?")[0];
      setUrl(distributionUrl);
      setIsImage(IMAGE_TYPES.includes(extension ?? ""));
      // FIXME: Automatically disabled during ESLint config update
    } catch {
      setUrl("");
    }
    setLoading(false);
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileStorageFileKey]);

  useEffect(() => {
    if (!fileStorageFileKey) {
      return;
    }
    void fetchFile();
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileStorageFileKey]);

  const handleImageClick = () => {
    if (isPreviewImage) {
      setImagePath(url);
    }
  };

  const handleImageViewerClose = () => {
    setImagePath("");
  };

  const handleCorruptImage = () => {
    if (!setLicense) {
      return;
    }
    showErrorToast("Problem accessing image; please notify Engineering");
    setLicense({
      ...license,
      fileStorageFileKey: undefined,
      fileStorageRootFolder: "",
      fileName: undefined,
    });
  };

  if (loading) {
    return <div>loading...</div>;
  } else if (isImage) {
    return (
      <>
        {/* FIXME: Automatically disabled during ESLint config update */}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
        <img
          data-testid="license-doc-preview-image"
          className={isPreviewImage ? "preview-img" : ""}
          style={{ maxWidth: width || "100%", maxHeight: height || "100%" }}
          src={url}
          alt="preview"
          title={isPreviewImage ? "Click on the image to rotate, zoom it" : ""}
          onClick={handleImageClick}
          onError={handleCorruptImage}
        />
        <ImageViewer
          visible={!!imagePath}
          images={[{ src: `${imagePath}`, alt: "Document" }]}
          onClose={handleImageViewerClose}
        />
      </>
    );
  } else {
    return (
      <Iframe
        url={url}
        width={width || "100%"}
        height={height || "100%"}
        display="inline"
        position="relative"
      />
    );
  }
};
